import React, { Component } from 'react';

class DescripcionEmpresa extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        let props = this.props;
        let labelDocumentoEmpresa;
        let descripcion = props.data.empresaDatos.Descripcion;
        let categoria = props.data.entidadInstaciasEquivalenciaCodigoIva;

        if (categoria) {
            categoria = categoria.Descripcion;
        } else {
            categoria = props.data.categoriaIva;
        }

        labelDocumentoEmpresa = <div>
            <div className="col-xs-8">
                <div>
                    <label className="label-primary">Descripción de la empresa (para identificarla en pantalla)</label>
                </div>
                <div>
                    <label className="label-secondary">{descripcion}</label>
                </div>
            </div>
            <div className="col-xs-4">
                <div>
                    <label className="label-primary">Tipo de IVA</label>
                </div>
                <div>
                    <label className="label-secondary">{categoria}</label>
                </div>
            </div>
        </div >

        return (
            <div className="row top-separator-xs">
                {labelDocumentoEmpresa}
            </div>
        );
    }
};

export default DescripcionEmpresa;